// extracted by mini-css-extract-plugin
module.exports = {"container":"RestaurantNotFound_container__p6ipn","icon":"RestaurantNotFound_icon__q4chh"};